var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PureAlert',{attrs:{"id":_vm.id,"alert":_vm.alert},on:{"alert-hidden":_vm.resetAlert}})
}
var staticRenderFns = []

export { render, staticRenderFns }